import { render, staticRenderFns } from "./NewSystemMeta.vue?vue&type=template&id=60cf6da2&scoped=true"
import script from "./NewSystemMeta.vue?vue&type=script&lang=js"
export * from "./NewSystemMeta.vue?vue&type=script&lang=js"
import style0 from "./NewSystemMeta.vue?vue&type=style&index=0&id=60cf6da2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf6da2",
  null
  
)

export default component.exports